import { Injectable, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ZoomDetectionService {

  constructor(@Inject(DOCUMENT) private document: Document) { }

  detectZoom(renderer: Renderer2): void {
    const zoomLevel = Math.round(window.devicePixelRatio * 100);   

 
    if(zoomLevel == 25){
      document.querySelector('.divvideo')?.setAttribute('style', '  top:130px !important;');      
    }    
    else if(zoomLevel == 33){
      document.querySelector('.divvideo')?.setAttribute('style', '  top:130px !important;');      
    }
    else if(zoomLevel == 50){
      document.querySelector('.divvideo')?.setAttribute('style', '  top:130px !important;');      
    }
    else if(zoomLevel > 50){
      document.querySelector('.divvideo')?.setAttribute('style', '  top:70px !important;');      
    }

    if(zoomLevel == 125){      
      document.querySelector('.clarapic')?.setAttribute('style', '  width:125% !important;');      
    }
    else 
    { 
      document.querySelector('.clarapic')?.setAttribute('style', '  width:135% !important;');           
    }
    
    if (zoomLevel == 80) {
      document.querySelector('.container-fluid-zoom')?.setAttribute('style', ' transform: scale(0.8);margin-top: 36px !important;max-width:1500px;height:auto');
    }
    else if (zoomLevel == 75) {
      document.querySelector('.container-fluid-zoom')?.setAttribute('style', ' transform: scale(0.85);margin-top: 40px !important;max-width:1500px;height:auto');
    }
    else if (zoomLevel == 67) {
      document.querySelector('.container-fluid-zoom')?.setAttribute('style', ' transform: scale(0.9);max-width:1500px;height:auto');
    }
    else if (zoomLevel == 50) {
      document.querySelector('.container-fluid-zoom')?.setAttribute('style', ' transform: scale(1.0);max-width:1700px;height:auto');        
    }
    else if (zoomLevel == 33) {
      document.querySelector('.container-fluid-zoom')?.setAttribute('style', ' transform: scale(1.3);max-width:1700px;height:auto');      
    }
    else if (zoomLevel == 25) {
      document.querySelector('.container-fluid-zoom')?.setAttribute('style', ' transform: scale(1.2);max-width:1700px;height:auto');      
    }
    else {
      document.querySelector('.container-fluid-zoom')?.setAttribute('style', ' max-width:1500px;height:auto');
    }



    const zoomedOutClass = this.document.querySelector('.zoomed-out');

    // If zoom level is less than 100%, apply the zoomed-out class to hide or adjust the top part
    if (zoomLevel < 100) {
      if (zoomedOutClass) {
        renderer.addClass(zoomedOutClass, 'zoomed-out'); // Add class to hide top part
      }
    } else {
      if (zoomedOutClass) {
        renderer.removeClass(zoomedOutClass, 'zoomed-out'); // Reset top part
      }
    }
  }
}
